// Product-analytics and error ingest must never be mirrored back to the
// collector — that is the request storm on chatty pages (replay chunks,
// Mixpanel, Sentry).
export const DEFAULT_IGNORED_COLLECTOR_URLS: Array<string | RegExp> = [
  /telemetry\.noddi\.(co|no)/i,
  /analytics\.noddi\.(co|no)/i,
  /errors\.noddi\.(co|no)/i,
  /signals\.noddi\.(co|no)/i,
  /(telemetry|analytics|errors|signals)\.bynavio\.com/i,
  /(telemetry|analytics|errors|signals)\.bynav\.io/i,
  /api(-eu)?\.mixpanel\.com/i,
  /ingest\.sentry\.io/i
];
